import React from 'react';
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs"

interface TaskFilterTabsProps {
  currentFilter: string; // Add prop for controlled state
  onFilterChange: (filter: string) => void; // Example prop
}

const TaskFilterTabs: React.FC<TaskFilterTabsProps> = ({ currentFilter, onFilterChange }) => {
  return (
    <Tabs value={currentFilter} onValueChange={onFilterChange} className="w-full mb-4">
      <TabsList className="grid w-full grid-cols-5"> {/* Adjust grid cols if needed */}
        <TabsTrigger value="all">All Tasks</TabsTrigger>
        <TabsTrigger value="today">Today</TabsTrigger>
        <TabsTrigger value="upcoming">Upcoming</TabsTrigger>
        <TabsTrigger value="completed">Completed</TabsTrigger>
        <TabsTrigger value="one_thing">ONE THING</TabsTrigger>
      </TabsList>
      {/* TabsContent could be used if each tab displayed significantly different content,
          but here we likely just filter the main TaskList based on the trigger clicked. */}
    </Tabs>
  );
};

export default TaskFilterTabs; 